import { isCreationKind } from '@sim/content/creation-kinds';
import type { BuildKind } from '@sim/content/subject-kind';
import type { BuildRequest } from '@sim/core/editing';

/**
 * The single place a dragged tool becomes a build request, so the ghost a drag paints and the drop
 * that follows it can never disagree about what would be built there.
 */
export function buildRequestFor(kind: BuildKind): BuildRequest {
  if (kind === 'subject') return { type: 'subject' };
  return isCreationKind(kind) ? { type: 'observable', kind } : { type: 'machine', kind };
}
